export default __webpack_public_path__ + "static/Toolbar-656104eebbc6e602366932327feef909.png";